import { Card, CardBody } from "reactstrap"
import ButtonTooltip from "components/Common/ButtonTooltip"
import PreOrderList from "pages/CustomerPages/CustomerProfile/PreOrder/PreOrderList"

export default function PreOrdersTab({ stock, onChanged, isRefetching = false }) {
  const preOrders = stock?.pre_orders || []
  const total = preOrders.length ?? 0

  return (
    <Card className="border-0 shadow-sm">
      <CardBody className="p-4">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <div>
            <h5 className="mb-0 fw-semibold">Pre-Orders</h5>
            <div className="text-muted small">Total: {total}</div>
          </div>
          <ButtonTooltip
            type="refresh"
            btnId="refreshStockPreOrders"
            size={null}
            loading={isRefetching}
            onClick={() => onChanged?.()}
          />
        </div>
        <PreOrderList data={preOrders} onChanged={onChanged} />
      </CardBody>
    </Card>
  )
}
